export default {
  namespaced: true,

  state() {
    return {
      tags: null,
      defaultTagIds: null,
      enrollmentSource: null,
      previousEnrollmentSource: null,
      disableHrisWarningDisplayed: false,
      channelJoins: null,
    };
  },

  mutations: {
    update(state, { key, value }) {
      state[key] = value;
    },

    updateChannelJoin(state, { idx, key, value }) {
      state.channelJoins[idx][key] = value;
    },

    addNewChannelJoin(state) {
      state.channelJoins.push({ tag_ids: [] });
    },

    deleteChannelJoinAtIdx(state, { idx }) {
      state.channelJoins.splice(idx, 1);
    },

    updateEnrollmentSource(state, newSource) {
      state.enrollmentSource = newSource;
    },
  },

  actions: {
    establishInitialState({ commit }, { tags, defaultTagIds, enrollmentSource, channelJoins }) {
      commit('update', { key: 'tags', value: tags });
      commit('update', { key: 'defaultTagIds', value: defaultTagIds });
      commit('update', { key: 'enrollmentSource', value: enrollmentSource });
      commit('update', { key: 'previousEnrollmentSource', value: enrollmentSource });
      commit('update', { key: 'channelJoins', value: channelJoins });
    },

    warnIfDisablingHrisOnboarding({ commit, state }, newSource) {
      if (state.previousEnrollmentSource === 'new_enrollment_rules'
          && newSource !== 'new_enrollment_rules'
          && !state.disableHrisWarningDisplayed) {
        commit('update', { key: 'disableHrisWarningDisplayed', value: true });
        commit('updateModal', {
          visible: true,
          subcomponent: 'onboarding-tags-enrollment-modals-disabling-hris-warning',
          size: 'l',
        }, { root: true });
      }
    },
  },
};
